(function (Drupal, $, once, drupalSettings) {
  'use strict';

  Drupal.behaviors.ucwsTableDataTable = {
    attach: function (context, settings) {

      //
      // Initialize all of the DataTable tables on the page.
      //
      if (typeof $.fn.dataTable === "function") {

        // Iterate over each table on the page.
        $(once('initialize', '.block.table table')).each(function (index) {

          // Count total number of content rows to determine initial pagination.
          var tableSize = $(':not(thead) tr', $(this)).length; // Disregard 'thead'.
          var tableChunkSize = 5;

          // Fire up the basic configured DataTable display!
          try{
            $(this).DataTable({
              order: [], // No pre-sorting by default.
              searching: false,
              info: false,
              paging: (tableSize > tableChunkSize),
              pageLength: tableChunkSize,
              pagingType: 'simple_numbers',
              lengthChange: (tableSize > tableChunkSize),
              lengthMenu: [ [tableChunkSize, -1], ['Show ' + tableChunkSize + ' of ' + tableSize + ' entries', 'Show all ' + tableSize + ' entries'] ],
              language: {
                lengthMenu: '_MENU_',
                paginate: {
                  previous: ' ',
                  next: ' ',
                }
              },
              drawCallback: function(settings) {
                $('.dataTables_wrapper .paginate_button.next > a').each(function () {
                  $(this).addClass('ucws-icon ucws-icon-chevron');
                });
                $('.dataTables_wrapper .paginate_button.previous > a').each(function () {
                  $(this).addClass('ucws-icon ucws-icon-chevron');
                });
                // Add the button role to the pager buttons so they don't get animated.
                $('.dataTables_wrapper .paginate_button > a').each(function () {
                  $(this).attr('role', 'button');
                });
              },
              initComplete: function () {
                // Rock and roll - initialize Bootstrap Select!
                $('.dataTables_length select').selectpicker();
                // Now we can safely wrap the table too!
                $(this).wrap('<div class="scroller"></div>');
              },
            });
          }
          // Lots of reasons this can fail (i.e. malformed table).
          catch (err) {
            // Error message may not be useful due to minimization...
            console.log('DataTable loading error: ' + err.message);
            // Still wrap the table.
            $(this).wrap('<div class="scroller"></div>');
          }
        });
      }
    }
  };
})(Drupal, jQuery, once, drupalSettings);
